import { Translation } from 'cng-common/features/translations'
import { IColumn } from 'core-components/library/list/types'

import { ESP_TRANSLATION_KEYS } from '../../../configs/translations'
import { IEspAttentionRow } from '../../../lib/getEspDashboardStats'
import { EspBadge } from '../../espBadge/EspBadge'

const KEYS = ESP_TRANSLATION_KEYS.dashboard

export const getAttentionColumns = (): IColumn<IEspAttentionRow>[] => [
  {
    field: 'partnerName',
    title: KEYS.columnPartner,
    disableSort: true,
    hideSettings: true,
    titleRender: () => <Translation text={KEYS.columnPartner} />,
    renderFunction: (item) => <>{item.partnerName}</>,
  },
  {
    field: 'sponsorName',
    title: KEYS.columnSponsor,
    disableSort: true,
    hideSettings: true,
    titleRender: () => <Translation text={KEYS.columnSponsor} />,
    renderFunction: (item) => <>{item.sponsorName || '—'}</>,
  },
  {
    field: 'lastActivityDate',
    title: KEYS.columnLastActivity,
    disableSort: true,
    hideSettings: true,
    titleRender: () => <Translation text={KEYS.columnLastActivity} />,
    renderFunction: (item) =>
      item.lastActivityDate ? (
        <>{new Date(item.lastActivityDate).toLocaleDateString()}</>
      ) : (
        <EspBadge variant="negative" labelKey={KEYS.noneLogged} />
      ),
  },
  {
    field: 'activitiesCount',
    title: KEYS.columnActivities,
    disableSort: true,
    hideSettings: true,
    titleRender: () => <Translation text={KEYS.columnActivities} />,
    renderFunction: (item) => <>{item.activitiesCount}</>,
  },
]
